import React from "react";
import Sidebar from "../components/Sidebar";
import { useState, useEffect } from "react";

const Applications = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch applications from the server
    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await fetch("http://localhost:8081/applications");
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                setApplications(data);
                setLoading(false);
            }
            catch (error) {
                console.error("Error fetching applications:", error);
                setLoading(false);
            }
        }
        fetchApplications();
    }
    , []);
    return (
        <div className="content">
        <Sidebar />
        <div className='main-content'>
            <h1>Applications</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <ul className="applications-list">
                    {applications.map((application, index) => (
                        <li key={index} className="application-item">
                            <h2>{application.name}</h2>
                            <p>{application.description}</p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
        </div>
    );
}
export default Applications;